import React, { useState, forwardRef, useEffect, Fragment } from "react";
import { Button, Modal, Offcanvas } from "react-bootstrap";
import swal from "sweetalert";
import { useStripe, useElements, CardElement } from "@stripe/react-stripe-js";
import AdminPaymentService from "../../../API/Services/AdminService/AdminPaymentService";

const PaymentOffcanvas = forwardRef((props, ref) => {
  const { canvasShowAdd, seCanvasShowAdd } = props;

  const [error, setError] = useState("");
  const [clientSecret, setClientSecret] = useState("");
  const [isApply, setIsApply] = useState(false);

  const stripe = useStripe();
  const elements = useElements();

  useEffect(() => {
    if (canvasShowAdd) {
      GetClientSecret();
      setError("");
    }
  }, [canvasShowAdd]);

  const GetClientSecret = async () => {
    try {
      const response = await AdminPaymentService.getClientSecret();

      const data = await response.json();

      const { client_secret } = data;
      setClientSecret(client_secret);
    } catch (error) {
      if (error.name === "HTTPError") {
        const errorJson = await error.response.json();
      }
    }
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    setIsApply(true);

    if (!stripe || !elements) {
      setError("Stripe has not been properly initialized.");
      return;
    }

    try {
      const result = await stripe.confirmCardSetup(clientSecret, {
        payment_method: {
          card: elements.getElement(CardElement),
        },
      });

      if (result.error) {
        setIsApply(false);
        setError(result.error.message);
      } else {
        if (result) {
          setIsApply(false);
          swal("Payment method added Successfully.");
          seCanvasShowAdd(false);
          props.parentCallback();
        }
      }
    } catch (err) {
      setIsApply(false);
      setError(err.message || "An unexpected error occurred.");
    }
  };

  return (
    <Fragment>
      <Modal
        show={canvasShowAdd}
        onHide={() => seCanvasShowAdd(false)}
        centered
        backdrop="static" // Prevents closing when clicking outside (optional)
        keyboard={false}
      >
        <Modal.Header closeButton>
          <Modal.Title>{props.Title}</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <div className="container-fluid p-0">
            <form onSubmit={handleSubmit}>
              <div className="row">
                {/* Changed to col-12 for full width in modal */}
                <div className="col-12 mb-3">
                  <label htmlFor="card-element" className="form-label">
                    Card Details <span className="text-danger">*</span>
                  </label>

                  <div className="form-control stripe-input">
                    <CardElement
                      id="card-element"
                      options={{
                        style: {
                          base: {
                            fontSize: "15px",
                            color: "#495057",
                            fontFamily: "inherit",
                            lineHeight: "24px",
                            "::placeholder": { color: "#6c757d" },
                          },
                          invalid: { color: "#dc3545" },
                        },
                      }}
                    />
                  </div>
                </div>
                <p className="text-danger fs-12">{error}</p>
              </div>

              <div className="d-flex justify-content-end mt-2">
                <Button
                  variant="danger"
                  className="light me-2"
                  onClick={() => seCanvasShowAdd(false)}
                  type="button"
                >
                  Cancel
                </Button>
                <Button
                  variant="primary"
                  type="submit"
                  disabled={isApply}
                >
                  {isApply ? "Submitting..." : "Submit"}
                </Button>
              </div>
            </form>
          </div>
        </Modal.Body>
      </Modal>
      {/* <Offcanvas
        show={canvasShowAdd}
        onHide={seCanvasShowAdd}
        className="offcanvas-end customeoff"
        placement="end"
      >
        <div className="offcanvas-header">
          <h5 className="modal-title">{props.Title}</h5>
          <button
            type="button"
            className="btn-close"
            onClick={() => {
              seCanvasShowAdd(false);
            }}
          >
            <i className="fa-solid fa-xmark"></i>
          </button>
        </div>

        <div className="offcanvas-body">
          <div className="container-fluid">
            <form onSubmit={handleSubmit}>
              <div className="row">
                <div className="col-xl-6 mb-3">
                  <label htmlFor="card-element" className="form-label">
                    Card Details <span className="text-danger">*</span>
                  </label>

                  <div className="form-control stripe-input">
                    <CardElement
                      id="card-element"
                      options={{
                        style: {
                          base: {
                            fontSize: "15px",
                            color: "#495057",
                            fontFamily: "inherit",
                            lineHeight: "24px",
                            "::placeholder": { color: "#6c757d" },
                          },
                          invalid: { color: "#dc3545" },
                        },
                      }}
                    />
                  </div>
                </div>
                <p className="text-danger fs-12">{error}</p>
              </div>

              <div>
                <button
                  disabled={isApply}
                  type="submit"
                  className="btn btn-primary me-1"
                >
                  {isApply ? "Submitting..." : "Submit"}
                </button>
                <button
                  type="button"
                  onClick={() => {
                    seCanvasShowAdd(false);
                  }}
                  className="btn btn-danger light ms-1"
                >
                  Cancel
                </button>
              </div>
            </form>
          </div>
        </div>
      </Offcanvas> */}
    </Fragment>
  );
});

export default PaymentOffcanvas;